<template>
  <div
    :class="[
      'zg-flex',
      `zg-flex--direction-${direction}`,
      `zg-flex--align-items-${alignItems}`,
      `zg-flex--justify-content-${justifyContent}`,
      `zg-flex--gap-${gap}`,
      { 'zg-flex--wrap': wrap }
    ]"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ZgFlex',
    props: {
      direction: {
        type: String,
        default: 'row',
        validator: value => [
          'column',
          'row'
        ].includes(value)
      },
      alignItems: {
        type: String,
        default: 'stretch',
        validator: value => [
          'stretch',
          'flex-start',
          'flex-end',
          'center',
          'baseline'
        ].includes(value)
      },
      justifyContent: {
        type: String,
        default: 'flex-start',
        validator: value => [
          'start',
          'end',
          'flex-start',
          'flex-end',
          'center',
          'left',
          'right',
          'normal',
          'space-between',
          'space-around',
          'space-evenly',
          'stretch'
        ].includes(value)
      },
      gap: {
        type: String,
        default: 'base',
        validator: value => [
          'xsmall',
          'small',
          'base',
          'medium',
          'large'
        ].includes(value)
      },
      wrap: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
  $directions: column, row;
  $alignItems: stretch, flex-start, flex-end, center, baseline;
  $justifyContent: start, end, flex-start, flex-end, center, left, right, normal, space-between, space-around, space-evenly, stretch;
  $gaps: xsmall, small, base, medium, large;

  .zg-flex {
    display: flex;
    justify-content: center;

    @each $item in $directions {
      &--direction-#{$item} {
        flex-direction: $item;
      }
    }

    @each $item in $alignItems {
      &--align-items-#{$item} {
        align-items: $item;
      }
    }

    @each $item in $justifyContent {
      &--justify-content-#{$item} {
        justify-content: $item;
      }
    }

    @each $gap in $gaps {
      &--gap-#{$gap} {
        grid-gap: rhythm($gap);
      }
    }

    &--wrap {
      flex-wrap: wrap;
    }
  }
</style>
